import React from "react";
import styled from "styled-components";

export interface PageTitleProps {
  title: string;
  text: string;
}

const PageTitle: React.FC<PageTitleProps> = ({ title = "", text = "" }) => (
  <div>
    <Title>{title}</Title>
    <Text>{text}</Text>
  </div>
);

export default PageTitle;

const Title = styled.h1`
  margin-bottom: 3rem;
`;

const Text = styled.p`
  margin-bottom: 3rem;
  font-size: 14px;
  line-height: 1.7;
  letter-spacing: 0;
  font-weight: normal;
  white-space: pre-wrap;
`;
